import { Box, IconButton, InputBase, Paper } from '@mui/material';
import * as React from 'react';
import { Palette, Sizes } from '../../@shared/palette';
import SearchIcon from '@mui/icons-material/Search';
import { UseLeftPanelResult } from '../../hooks/useLeftPanel';
import { useSelector } from 'react-redux';
import { getSearchValue, setSearchValue } from '../../reducers/data/dataReducer';
import { useDispatch } from 'react-redux';


type SearchInputProps = {
  leftPanelHook: UseLeftPanelResult
}

const SearchInput = (props: SearchInputProps) => {
  const searchValue = useSelector(getSearchValue);
  const [lastSearch, setLastSearch] = React.useState<string | undefined>();
  const [isSearchUpdated, setIsSearchUpdated] = React.useState<boolean>(false);

  const dispatch = useDispatch();
  const onSetSearchValue = React.useCallback((v: string) => {
    setIsSearchUpdated(true);
    dispatch(setSearchValue(v));
  }, [dispatch]);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (props.leftPanelHook && searchValue !== lastSearch && isSearchUpdated) {
        props.leftPanelHook.onLoadWithCleaning();
        setLastSearch(searchValue);
      }
    }, 1000)
    return () => {
      clearTimeout(timer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue])

  return <Box sx={{ padding: "10px 2px 10px 8px" }}>
    <Paper
      component="form"
      sx={{
        display: 'flex',
        backgroundColor: Palette.backgroundColorPrimary,
        padding: "5px 5px",
        alignItems: 'center',
        width: "100%"
      }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1, color: Palette.textColorPrimary, fontSize: Sizes.textPrimary }}
        placeholder="Search"
        value={searchValue}
        onKeyDown={(e => {
          if (e.key === "Enter") {
            props.leftPanelHook.onLoadWithCleaning();
            e.stopPropagation();
            e.preventDefault();
          }
        })}
        onChange={(e) => onSetSearchValue(e.currentTarget.value)}
        inputProps={{ 'aria-label': 'search' }}
      />
      <IconButton type="button" sx={{ p: '5px', color: Palette.textColorSecondary, }} aria-label="search" onClick={props.leftPanelHook.onLoadWithCleaning}>
        <SearchIcon />
      </IconButton>
    </Paper>
  </Box>
}




export default SearchInput;

